(function () {
  const DEFAULT_POLL_INTERVAL = 2500;
  const DEFAULT_POLL_TIMEOUT = 120000;
  const DEVICE_KEY = "cs_tryon_device_id";
  const instances = new WeakMap();

  function getDeviceId() {
    try {
      let value = localStorage.getItem(DEVICE_KEY);
      if (!value) {
        value = "dev_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
        localStorage.setItem(DEVICE_KEY, value);
      }
      return value;
    } catch (error) {
      return "";
    }
  }

  function safeDateLabel(input) {
    try {
      const d = new Date(input);
      if (Number.isNaN(d.getTime())) return "";
      return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
    } catch (error) {
      return "";
    }
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  class ChinaSquadTryOn {
    constructor(root) {
      this.root = root;
      this.syncConfig();

      this.state = {
        selectedVariantId: "",
        selectedVariantImage: "",
        selectedVariantTitle: "",
        productFirstImage: "",
        userFile: null,
        userImageUrl: "",
        uploadedUserImageUrl: "",
        taskId: "",
        isSubmitting: false,
        deviceId: getDeviceId(),
      };

      this.mountModalToBody();
      this.refreshElements();
      this.syncVariantFromPage();
      this.state.productFirstImage = this.getProductFirstImage();
      this.showMainPage();
    }

    syncConfig() {
      this.apiBase = this.root.dataset.apiBase || "";
      this.productId = this.root.dataset.productId || "";
      this.shopDomain = this.root.dataset.shopDomain || "";
      this.moneyFormat = this.root.dataset.moneyFormat || "${{amount}}";
      this.customerId = this.root.dataset.customerId || "";
      this.productUrl = this.root.dataset.productUrl || window.location.href;
    }


    getProductFirstImage() {
      // Try to read from Shopify product JSON embedded in the page
      try {
        const s = this.root.querySelector('[data-product-json]');
        if (s && s.textContent) {
          const j = JSON.parse(s.textContent);
          const featured = j.featured_image || j.featuredImage || (j.image && j.image.src) || j.image;
          if (typeof featured === 'string' && featured) return featured;
          if (Array.isArray(j.images) && j.images[0]) return j.images[0];
        }
      } catch (e) {}

      // Fallback: some themes expose featured image via data attributes
      return this.root.dataset.productImage || this.root.dataset.productFeaturedImage || '';
    }

    mountModalToBody() {
      const modal = this.root.querySelector("[data-tryon-modal]");
      if (!modal) return;
      if (modal.dataset.tryonMountedToBody === "true") return;

      const modalId =
        this.root.dataset.tryonModalId ||
        "cs-tryon-" + Math.random().toString(36).slice(2, 10);

      this.root.dataset.tryonModalId = modalId;
      modal.dataset.tryonModalId = modalId;
      modal.dataset.tryonMountedToBody = "true";

      document.body.appendChild(modal);
    }

    getModal() {
      const modalId = this.root.dataset.tryonModalId || "";
      if (!modalId) return this.root.querySelector("[data-tryon-modal]");

      return document.querySelector(
        '[data-tryon-modal][data-tryon-modal-id="' + modalId + '"]'
      );
    }

    getDialog() {
      const modal = this.getModal();
      return modal ? modal.querySelector(".chinasquad-tryon__dialog") : null;
    }

    refreshElements() {
      this.syncConfig();
      const modal = this.getModal();

      this.els = {
        modal: modal,
        overlay: modal ? modal.querySelector("[data-tryon-overlay]") : null,
        fileInput: modal ? modal.querySelector("[data-tryon-file]") : null,
        previewImage: modal ? modal.querySelector("[data-tryon-preview-image]") : null,
        previewEmpty: modal ? modal.querySelector("[data-tryon-preview-empty]") : null,
        loading: modal ? modal.querySelector("[data-tryon-loading]") : null,
        resultWrap: modal ? modal.querySelector("[data-tryon-result-wrap]") : null,
        resultImage: modal ? modal.querySelector("[data-tryon-result-image]") : null,
        error: modal ? modal.querySelector("[data-tryon-error]") : null,
        selectedVariantText: modal ? modal.querySelector("[data-tryon-selected-variant]") : null,
        selectedProductImage: modal ? modal.querySelector("[data-tryon-selected-product-image]") : null,
        historyList: modal ? modal.querySelector("[data-tryon-history-list]") : null,
        historyCount: modal ? modal.querySelector("[data-tryon-history-count]") : null,
      };
    }

    isMobile() {
      return window.innerWidth <= 768;
    }

    applyResponsiveMode() {
      this.refreshElements();
      const dialog = this.getDialog();
      if (!dialog) return;

      if (this.isMobile()) {
        dialog.classList.add("cs-tryon-mobile-fullscreen");
      } else {
        dialog.classList.remove("cs-tryon-mobile-fullscreen");
      }
    }

    clearResponsiveMode() {
      this.refreshElements();
      const dialog = this.getDialog();
      if (!dialog) return;
      dialog.classList.remove("cs-tryon-mobile-fullscreen");
    }

    isOpen() {
      this.refreshElements();
      return !!(this.els.modal && this.els.modal.classList.contains("is-active"));
    }

    openModal() {
      this.refreshElements();
      if (!this.els.modal) return;

      this.clearResponsiveMode();
      this.applyResponsiveMode();
      this.syncVariantFromPage();
      this.state.productFirstImage = this.getProductFirstImage();
      this.showMainPage();

      this.els.modal.classList.add("is-active");
      document.documentElement.classList.add("tryon-modal-open");
      document.body.classList.add("tryon-modal-open");
    }

    closeModal() {
      this.refreshElements();
      if (!this.els.modal) return;

      this.els.modal.classList.remove("is-active");
      document.documentElement.classList.remove("tryon-modal-open");
      document.body.classList.remove("tryon-modal-open");

      this.clearResponsiveMode();
      this.showMainPage();
    }

    showPage(pageName) {
      const modal = this.getModal();
      if (!modal) return;

      const pages = modal.querySelectorAll("[data-tryon-page]");
      pages.forEach(function (page) {
        page.classList.remove("is-active");
      });

      const nextPage = modal.querySelector('[data-tryon-page="' + pageName + '"]');
      if (nextPage) nextPage.classList.add("is-active");
    }

    showMainPage() {
      this.showPage("main");
    }

    showHistoryPage() {
      this.showPage("history");
    }



    showSuccessPage() {
      this.showPage("success");
    }


    showLoadingPage() {
  this.showPage("loading");
}

showResultPage() {
  this.showPage("result");
}

setLoadingVisuals() {
  this.refreshElements();
  const modal = this.getModal();
  if (!modal) return;

  const userImg = modal.querySelector("[data-tryon-loading-user-image]");
  const garmentImg = modal.querySelector("[data-tryon-loading-garment-image]");
  const resultGarmentImg = modal.querySelector("[data-tryon-result-garment-image]");

  if (userImg) {
    userImg.src = this.state.userImageUrl || "";
  }

  if (garmentImg) {
    garmentImg.src = this.state.selectedVariantImage || "";
  }

  if (resultGarmentImg) {
    resultGarmentImg.src = this.state.selectedVariantImage || "";
  }
}

setLoadingProgress(percent, titleText) {
  const modal = this.getModal();
  if (!modal) return;

  const title = modal.querySelector("[data-tryon-loading-title]");
  const progressText = modal.querySelector("[data-tryon-loading-progress-text]");
  const progressBar = modal.querySelector("[data-tryon-loading-progressbar]");

  const safePercent = Math.max(0, Math.min(100, Number(percent) || 0));

  if (title && titleText) {
    title.textContent = titleText;
  }

  if (progressText) {
    progressText.textContent = safePercent + "%";
  }

  if (progressBar) {
    progressBar.style.width = safePercent + "%";
  }
}

startFakeLoadingProgress() {
  this.stopFakeLoadingProgress();

  const tips = [
    "Tip: Use a full body photo for best results",
    "Tip: Stand straight and keep your arms visible",
    "Tip: Use a plain background and good lighting",
    "Tip: Avoid group photos — one person only",
    "Tip: Make sure your full outfit is in frame"
  ];

  let tipIndex = 0;
  const tickMs = 650;
  const start = Date.now();
  const normalPhaseMs = 52000; // climb to 99% in ~50s

  const setTip = () => {
    const modal = this.getModal();
    if (!modal) return;
    const tipEl = modal.querySelector("[data-tryon-loading-tip]");
    if (!tipEl) return;
    tipEl.textContent = tips[tipIndex % tips.length];
  };

  const update = () => {
    const elapsed = Date.now() - start;

    let percent = Math.floor((elapsed / normalPhaseMs) * 99);
    if (percent < 0) percent = 0;
    if (percent > 99) percent = 99;

    let title = "Generating your try-on...";
    if (percent >= 99) {
      title = "Almost there...";
    } else if (percent >= 70) {
      title = "Refining details...";
    } else if (percent >= 40) {
      title = "Fitting garment silhouette...";
    } else {
      title = "Understanding body shape...";
    }

    this.setLoadingProgress(percent, title);

    if (percent >= 99) {
      const modal = this.getModal();
      if (modal) {
        const progressText = modal.querySelector("[data-tryon-loading-progress-text]");
        if (progressText) progressText.textContent = "99%";

        const tipEl = modal.querySelector("[data-tryon-loading-tip]");
        if (tipEl) tipEl.textContent = "Almost done — this may take a few more seconds.";
      }
    }
  };

  // initial
  setTip();
  this.setLoadingProgress(0, "Generating your try-on...");

  this._tipTimer = setInterval(() => {
    tipIndex += 1;
    setTip();
  }, 4200);

  this._loadingTimer = setInterval(update, tickMs);
  update();
}

stopFakeLoadingProgress() {
  if (this._loadingTimer) {
    clearInterval(this._loadingTimer);
    this._loadingTimer = null;
  }
}





    setError(message) {
      this.refreshElements();
      if (!this.els.error) return;
      this.els.error.textContent = message || "";
      this.els.error.style.display = message ? "block" : "none";
    }

    setLoading(loading, text) {
      this.refreshElements();
      if (!this.els.loading) return;
      this.els.loading.style.display = loading ? "block" : "none";
      if (text) this.els.loading.textContent = text;
    }

    resetFlow() {
      this.refreshElements();

      this.state.userFile = null;
      this.state.userImageUrl = "";
      this.state.uploadedUserImageUrl = "";
      this.state.taskId = "";
      this.state.isSubmitting = false;

      if (this.els.fileInput) this.els.fileInput.value = "";

      if (this.els.previewImage) {
        this.els.previewImage.src = "";
        this.els.previewImage.style.display = "none";
      }

      if (this.els.previewEmpty) {
        this.els.previewEmpty.style.display = "flex";
      }

      if (this.els.resultWrap) {
        this.els.resultWrap.style.display = "none";
      }

      if (this.els.resultImage) {
        this.els.resultImage.src = "";
      }

      this.setLoading(false);
      this.setError("");
      this.showMainPage();
    }

    handleUserFile(file) {
      this.refreshElements();

      const allowedTypes = ["image/jpeg", "image/png", "image/webp"];
      const maxSize = 10 * 1024 * 1024;

      if (!allowedTypes.includes(file.type)) {
        this.setError("Please upload a JPG, PNG, or WEBP image.");
        return;
      }

      if (file.size > maxSize) {
        this.setError("Image size must be under 10MB.");
        return;
      }

      this.state.userFile = file;
      this.setError("");

      if (this.state.userImageUrl) {
        try {
          URL.revokeObjectURL(this.state.userImageUrl);
        } catch (error) {}
      }

      const previewUrl = URL.createObjectURL(file);
      this.state.userImageUrl = previewUrl;

      if (this.els.previewImage) {
        this.els.previewImage.src = previewUrl;
        this.els.previewImage.style.display = "block";
      }

      if (this.els.previewEmpty) {
        this.els.previewEmpty.style.display = "none";
      }
    }

    async uploadUserImage() {
      if (!this.state.userFile) {
        throw new Error("Please upload your photo first.");
      }

      const formData = new FormData();
      formData.append("image", this.state.userFile);

      if (this.customerId) {
        formData.append("customerId", this.customerId);
      } else if (this.state.deviceId) {
        formData.append("deviceId", this.state.deviceId);
      }

      const response = await fetch(`${this.apiBase}/api/tryon/upload`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Failed to upload image.");
      }

      return data.imageUrl;
    }

    async startTryOn() {
      try {
        if (this.state.isSubmitting) return;

        this.refreshElements();
        this.syncVariantFromPage();
      this.state.productFirstImage = this.getProductFirstImage();

        if (!this.apiBase) {
          throw new Error("Missing API base URL.");
        }

        if (!this.productId) {
          throw new Error("Missing Shopify product ID.");
        }

        if (!this.state.selectedVariantId) {
          throw new Error("Please select a product variant first.");
        }

        if (!this.state.userFile) {
          throw new Error("Please upload your photo first.");
        }

        this.state.isSubmitting = true;
this.setError("");
this.setLoadingVisuals();
this.showLoadingPage();
this.startFakeLoadingProgress();

const uploadedUserImageUrl = await this.uploadUserImage();
this.state.uploadedUserImageUrl = uploadedUserImageUrl;

        const payload = {
          shopDomain: this.shopDomain,
          productId: this.productId,
          variantId: this.state.selectedVariantId,
          productTitle: (() => {
            try {
              const s = this.root.querySelector("[data-product-json]");
              if (s && s.textContent) {
                const j = JSON.parse(s.textContent);
                return j.title || "";
              }
            } catch (e) {}
            return this.root.dataset.productTitle || "";
          })(),
          variantTitle: this.state.selectedVariantTitle || "",
          productUrl: (this.productUrl && this.productUrl.indexOf("/")===0 ? (window.location.origin + this.productUrl) : (this.productUrl || window.location.href)),
          productImageUrl: (this.state.selectedVariantImage || this.state.productFirstImage || ""),
          customerId: this.customerId || null,
          deviceId: this.customerId ? null : this.state.deviceId || null,
          userImageUrl: uploadedUserImageUrl,
          garmentImageUrl: (this.state.selectedVariantImage || this.state.productFirstImage || null),
        };

        const response = await fetch(`${this.apiBase}/api/tryon/create`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.error || "Failed to create try-on task.");
        }

        this.state.taskId = data.taskId;
        await this.pollResult(data.taskId);
      } catch (error) {
        this.stopFakeLoadingProgress();
this.showMainPage();
this.setError(error.message || "Try-on failed.");
      } finally {
        this.state.isSubmitting = false;
      }
    }

    async pollResult(taskId) {
  const startTime = Date.now();

  while (Date.now() - startTime < DEFAULT_POLL_TIMEOUT) {
    const response = await fetch(
      `${this.apiBase}/api/tryon/result?taskId=${encodeURIComponent(taskId)}`
    );
    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || "Failed to get try-on result.");
    }

    if (data.status === "success") {
      this.stopFakeLoadingProgress();
      this.setLoadingProgress(100, "Your try-on is ready");
      this.renderResult(data.resultImageUrl);
      this.showSuccessPage();
      return;
    }

    if (data.status === "failed") {
      throw new Error(data.error || "Try-on generation failed.");
    }

    await this.sleep(DEFAULT_POLL_INTERVAL);
  }

  throw new Error("Try-on timed out. Please try again.");
}

    renderResult(resultImageUrl) {
  this.refreshElements();
  if (!this.els.resultImage) return;

  this.els.resultImage.src = resultImageUrl;
}

    async fetchHistory() {
      this.refreshElements();

      if (!this.apiBase) {
        throw new Error("Missing API base URL.");
      }

      const customerId = this.customerId || "";
      const deviceId = this.state.deviceId || getDeviceId();
      const qs = customerId
        ? `customerId=${encodeURIComponent(customerId)}`
        : `deviceId=${encodeURIComponent(deviceId)}`;

      const response = await fetch(`${this.apiBase}/api/tryon/history?${qs}&limit=20`);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Failed to load history.");
      }

      return data.items || [];
    }


    async deleteHistoryItem(historyId) {
  if (!this.apiBase) {
    throw new Error("Missing API base URL.");
  }

  if (!historyId) {
    throw new Error("Missing history id.");
  }

  const query = new URLSearchParams();

  if (this.customerId) {
    query.set("customerId", this.customerId);
  } else if (this.state.deviceId) {
    query.set("deviceId", this.state.deviceId);
  } else {
    throw new Error("Missing customerId or deviceId.");
  }

  const response = await fetch(
    `${this.apiBase}/api/tryon/history/${encodeURIComponent(historyId)}?${query.toString()}`,
    {
      method: "DELETE",
    }
  );

  const data = await response.json();

  if (!response.ok || !data.ok) {
    throw new Error(data.error || "Failed to delete history item.");
  }

  return data;
}





    renderHistory(items) {
      this.refreshElements();
      const modal = this.getModal();
      const list = modal ? modal.querySelector("[data-tryon-history-list]") : null;
      const count = modal ? modal.querySelector("[data-tryon-history-count]") : null;

      if (!list) return;

      const safeItems = Array.isArray(items) ? items : [];

      if (count) {
        count.textContent =
          safeItems.length + (safeItems.length === 1 ? " result" : " results");
      }

      if (!safeItems.length) {
        list.innerHTML =
          '<div class="chinasquad-tryon__history-empty">No try-ons yet.</div>';
        return;
      }

      list.innerHTML = safeItems
        .map((item) => {
          const dateText = safeDateLabel(item.created_at);
          const resultImage = item.result_image_url || "";
          const garmentImage =
            item.product_image_url ||
            item.garment_image_url ||
            item.product_image_url ||
            this.state.selectedVariantImage ||
            "";
          const title =
            item.product_title ||
            item.variant_title ||
            
            this.state.selectedVariantTitle ||
            "Try-On Result";
          const productUrl = item.product_url || this.productUrl || window.location.href;

          return `
            <article class="chinasquad-tryon__history-card" data-tryon-history-id="${escapeHtml(item.id || "")}">
              <div class="chinasquad-tryon__history-card-media">
                <img
                  class="chinasquad-tryon__history-card-result"
                  src="${escapeHtml(resultImage)}"
                  alt="${escapeHtml(title)}"
                >
                ${
                  garmentImage
                    ? `
                      <div class="chinasquad-tryon__history-card-garment">
                        <img src="${escapeHtml(garmentImage)}" alt="${escapeHtml(title)}">
                      </div>
                    `
                    : ""
                }
              </div>

              <div class="chinasquad-tryon__history-card-body">
                <div class="chinasquad-tryon__history-card-meta">
                  <h4 class="chinasquad-tryon__history-card-title">${escapeHtml(title)}</h4>
                  <div class="chinasquad-tryon__history-card-date">${escapeHtml(dateText)}</div>
                </div>
              </div>

<div class="chinasquad-tryon__history-card-actions">
  <a
    class="chinasquad-tryon__history-action-main"
    href="${escapeHtml(productUrl)}"
    target="_blank"
    rel="noopener"
  >
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M7 7h10v14H7z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M9 7V5a3 3 0 0 1 6 0v2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
    </svg>
    <span>Go to Product</span>
  </a>

  <button type="button" class="chinasquad-tryon__history-action-icon is-liked" data-tryon-history-like aria-label="Like">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M12 20.2L10.55 18.88C5.4 14.22 2 11.14 2 7.35C2 4.52 4.24 2.4 7.05 2.4C8.64 2.4 10.16 3.12 11.1 4.25C12.04 3.12 13.56 2.4 15.15 2.4C17.96 2.4 20.2 4.52 20.2 7.35C20.2 11.14 16.8 14.22 11.65 18.88L12 20.2Z"
        stroke="currentColor"
        stroke-width="1.65"
        stroke-linecap="round"
        stroke-linejoin="round"/>
    </svg>
    </button>

  <button type="button" class="chinasquad-tryon__history-action-icon" data-tryon-history-share aria-label="Share">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M15 8L19.5 3.5M19.5 3.5H16.2M19.5 3.5V6.8"
        stroke="currentColor"
        stroke-width="1.65"
        stroke-linecap="round"
        stroke-linejoin="round"/>
      <path d="M10 5.5H8.2C5.93 5.5 4.8 5.5 4.1 6.2C3.4 6.9 3.4 8.03 3.4 10.3V15.8C3.4 18.07 3.4 19.2 4.1 19.9C4.8 20.6 5.93 20.6 8.2 20.6H13.7C15.97 20.6 17.1 20.6 17.8 19.9C18.5 19.2 18.5 18.07 18.5 15.8V14"
        stroke="currentColor"
        stroke-width="1.65"
        stroke-linecap="round"
        stroke-linejoin="round"/>
    </svg>
    </button>

  <button type="button" class="chinasquad-tryon__history-action-icon is-delete" data-tryon-history-delete aria-label="Delete">
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M4.4 6.7H19.6" stroke="currentColor" stroke-width="1.85" stroke-linecap="round"/>
      <path d="M8.9 4.5H15.1" stroke="currentColor" stroke-width="1.85" stroke-linecap="round"/>
      <rect x="6.2" y="6.7" width="11.6" height="11.2" rx="2" stroke="currentColor" stroke-width="1.85"/>
      <path d="M9.45 9.05V15.05" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
      <path d="M12 9.05V15.05" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
      <path d="M14.55 9.05V15.05" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
    </svg>
    </button>
</div>
            </article>
          `;
        })
        .join("");
    }




updateHistoryCount() {
  this.refreshElements();
  const modal = this.getModal();
  const list = modal ? modal.querySelector("[data-tryon-history-list]") : null;
  const count = modal ? modal.querySelector("[data-tryon-history-count]") : null;

  if (!list || !count) return;

  const cards = list.querySelectorAll(".chinasquad-tryon__history-card");
  const total = cards.length;

  count.textContent = total + (total === 1 ? " result" : " results");

  if (total === 0) {
    list.innerHTML = '<div class="chinasquad-tryon__history-empty">No try-ons yet.</div>';
  }
}



    
    async sendFeedback(action) {
      try {
        if (!this.apiBase) return;
        if (!this.state.taskId) return;

        const payload = {
          taskId: this.state.taskId,
          action: action,
          customerId: this.customerId || null,
          deviceId: this.customerId ? null : this.state.deviceId || null,
        };

        await fetch(`${this.apiBase}/api/tryon/feedback`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
      } catch (e) {}
    }


    async downloadResultImage() {
      const modal = this.getModal();
      const img = modal ? modal.querySelector("[data-tryon-result-image]") : null;
      const url = img && img.getAttribute("src") ? img.getAttribute("src") : "";
      if (!url) throw new Error("Missing result image.");

      const a = document.createElement("a");
      a.href = url;
      a.download = "tryon-result.jpg";
      document.body.appendChild(a);
      a.click();
      a.remove();
    }


    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    }

    syncVariantFromPage() {
      this.refreshElements();

      const variantId =
        this.getVariantIdFromForm() ||
        this.getVariantIdFromUrl() ||
        this.getVariantIdFromJson();

      if (!variantId) return;

      const variantData = this.getVariantDataById(variantId);

      this.state.selectedVariantId = String(variantId);

      if (variantData) {
        this.state.selectedVariantTitle =
          variantData.public_title ||
          variantData.name ||
          variantData.title ||
          "";

        this.state.selectedVariantImage =
          (variantData.featured_image &&
            (variantData.featured_image.src || variantData.featured_image.url)) ||
          variantData.image ||
          "";
      } else {
        this.state.selectedVariantTitle = "";
        this.state.selectedVariantImage = "";
      }

      if (this.els.selectedVariantText) {
        this.els.selectedVariantText.textContent =
          this.state.selectedVariantTitle || `Variant #${variantId}`;
      }

      if (this.els.selectedProductImage && this.state.selectedVariantImage) {
        this.els.selectedProductImage.src = this.state.selectedVariantImage;
      }
    }

    getVariantIdFromForm() {
      const scope = this.root.closest("section, product-info, main, body") || document;

      const formVariantInput =
        scope.querySelector("form[action*='/cart/add'] [name='id']") ||
        scope.querySelector("product-form [name='id']") ||
        scope.querySelector("input[name='id']") ||
        scope.querySelector("select[name='id']");

      if (!formVariantInput) return "";
      return formVariantInput.value || formVariantInput.getAttribute("value") || "";
    }

    getVariantIdFromUrl() {
      const params = new URLSearchParams(window.location.search);
      return params.get("variant") || "";
    }

    getVariantIdFromJson() {
      const productJsonScript = this.root.querySelector("[data-product-json]");
      if (!productJsonScript) return "";

      try {
        const productData = JSON.parse(productJsonScript.textContent);

        if (productData.selected_or_first_available_variant?.id) {
          return productData.selected_or_first_available_variant.id;
        }

        if (productData.variants && productData.variants[0]?.id) {
          return productData.variants[0].id;
        }
      } catch (error) {
        console.warn("Failed to parse product JSON", error);
      }

      return "";
    }

    getVariantDataById(variantId) {
      const productJsonScript = this.root.querySelector("[data-product-json]");
      if (!productJsonScript) return null;

      try {
        const productData = JSON.parse(productJsonScript.textContent);
        const variants = productData.variants || [];
        return (
          variants.find((variant) => String(variant.id) === String(variantId)) || null
        );
      } catch (error) {
        console.warn("Failed to parse variant data", error);
        return null;
      }
    }
  }

  function getInstanceFromRoot(root) {
    if (!root) return null;

    let instance = instances.get(root);

    if (!instance) {
      instance = new ChinaSquadTryOn(root);
      instances.set(root, instance);
    } else {
      instance.refreshElements();
      instance.syncVariantFromPage();
    }

    return instance;
  }

  function getInstanceFromElement(element) {
    const root = element.closest("[data-chinasquad-tryon]");
    return getInstanceFromRoot(root);
  }

  function getInstanceFromModalChild(element) {
    const modal = element.closest("[data-tryon-modal]");
    if (!modal) return null;

    const modalId = modal.dataset.tryonModalId || "";
    if (!modalId) return null;

    const root = document.querySelector(
      '[data-chinasquad-tryon][data-tryon-modal-id="' + modalId + '"]'
    );

    return getInstanceFromRoot(root);
  }

  function getModalFromRoot(root) {
    const modalId = root.dataset.tryonModalId || "";
    if (!modalId) return root.querySelector("[data-tryon-modal]");

    return document.querySelector(
      '[data-tryon-modal][data-tryon-modal-id="' + modalId + '"]'
    );
  }

  document.addEventListener("click", async function (event) {
    const openBtn = event.target.closest("[data-cs-tryon-trigger], [data-tryon-open]");
    if (openBtn) {
      const instance = getInstanceFromElement(openBtn);
      if (!instance) return;
      event.preventDefault();
      instance.openModal();
      return;
    }

    const closeBtn = event.target.closest("[data-tryon-close]");
    if (closeBtn) {
      const instance = getInstanceFromModalChild(closeBtn);
      if (!instance) return;
      event.preventDefault();
      instance.closeModal();
      return;
    }

    const overlay = event.target.closest("[data-tryon-overlay]");
    if (overlay) {
      const instance = getInstanceFromModalChild(overlay);
      if (!instance) return;
      event.preventDefault();
      instance.closeModal();
      return;
    }

    const chooseBtn = event.target.closest("[data-tryon-choose]");
    if (chooseBtn) {
      const instance = getInstanceFromModalChild(chooseBtn);
      if (!instance) return;
      event.preventDefault();
      instance.refreshElements();
      if (instance.els.fileInput) {
        instance.els.fileInput.click();
      }
      return;
    }

    const startBtn = event.target.closest("[data-tryon-start]");
    if (startBtn) {
      const instance = getInstanceFromModalChild(startBtn);
      if (!instance) return;
      event.preventDefault();
      instance.startTryOn();
      return;
    }

    const resetBtn = event.target.closest("[data-tryon-reset]");
    if (resetBtn) {
      const instance = getInstanceFromModalChild(resetBtn);
      if (!instance) return;
      event.preventDefault();
      instance.resetFlow();
      return;
    }

    const historyOpenBtn = event.target.closest("[data-tryon-history-open]");
    if (historyOpenBtn) {
      const instance = getInstanceFromModalChild(historyOpenBtn);
      if (!instance) return;
      event.preventDefault();

      try {
        const items = await instance.fetchHistory();
        instance.renderHistory(items);
        instance.showHistoryPage();
      } catch (error) {
        instance.setError(error.message || "Failed to load history.");
      }
      return;
    }

    const historyBackBtn = event.target.closest("[data-tryon-history-back]");
if (historyBackBtn) {
  const instance = getInstanceFromModalChild(historyBackBtn);
  if (!instance) return;
  event.preventDefault();
  instance.showMainPage();
  return;
}



    const resultBackBtn = event.target.closest("[data-tryon-result-back]");
if (resultBackBtn) {
  const instance = getInstanceFromModalChild(resultBackBtn);
  if (!instance) return;
  event.preventDefault();
  instance.showMainPage();
  return;
}

const resultShareBtn = event.target.closest("[data-tryon-result-share]");
if (resultShareBtn) {
  const instance = getInstanceFromModalChild(resultShareBtn);
  if (!instance) return;
  event.preventDefault();

  const shareUrl = window.location.href;
  try { await (async()=>instance.sendFeedback("share"))(); } catch(e) {}
  if (navigator.share) {
    try {
      await navigator.share({ url: shareUrl });
    } catch (error) {}
  } else {
    try {
      await navigator.clipboard.writeText(shareUrl);
      alert("Link copied");
    } catch (error) {
      alert(shareUrl);
    }
  }
  return;
}



const successBackBtn = event.target.closest("[data-tryon-success-back]");
if (successBackBtn) {
  const instance = getInstanceFromModalChild(successBackBtn);
  if (!instance) return;
  event.preventDefault();
  instance.showMainPage();
  return;
}

const successDownloadBtn = event.target.closest("[data-tryon-success-download]");
if (successDownloadBtn) {
  const instance = getInstanceFromModalChild(successDownloadBtn);
  if (!instance) return;
  event.preventDefault();
  instance.sendFeedback("download");
  instance.downloadResultImage().catch((error) => {
    alert(error.message || "Download failed");
  });
  return;
}

const successLikeBtn = event.target.closest("[data-tryon-success-like]");
if (successLikeBtn) {
  const instance = getInstanceFromModalChild(successLikeBtn);
  if (!instance) return;
  event.preventDefault();

  instance.sendFeedback("like");

  try { successLikeBtn.classList.toggle("is-liked"); } catch (e) {}
  return;
}

const successShareBtn = event.target.closest("[data-tryon-success-share]");
if (successShareBtn) {
  const instance = getInstanceFromModalChild(successShareBtn);
  if (!instance) return;
  event.preventDefault();

  instance.sendFeedback("share");

  const shareUrl = window.location.href;
  if (navigator.share) {
    try {
      await navigator.share({ url: shareUrl });
    } catch (error) {}
  } else {
    try {
      await navigator.clipboard.writeText(shareUrl);
      alert("Link copied");
    } catch (error) {
      alert(shareUrl);
    }
  }
  return;
}


const historyItem = event.target.closest(".chinasquad-tryon__history-card");
if (historyItem) {
  if (event.target.closest("[data-tryon-history-share]")) {
    event.preventDefault();
    const shareUrl = window.location.href;
  try { await (async()=>instance.sendFeedback("share"))(); } catch(e) {}
    if (navigator.share) {
      try {
        await navigator.share({ url: shareUrl });
      } catch (error) {}
    } else {
      try {
        await navigator.clipboard.writeText(shareUrl);
        alert("Link copied");
      } catch (error) {
        alert(shareUrl);
      }
    }
    return;
  }

  if (event.target.closest("[data-tryon-history-like]")) {
    const instance = getInstanceFromModalChild(historyItem);
    if (!instance) return;
    event.preventDefault();
    instance.state.taskId = historyItem.getAttribute("data-tryon-history-id") || instance.state.taskId;
    instance.sendFeedback("like");
    try {
      const likeBtn = historyItem.querySelector("[data-tryon-history-like]");
      const dislikeBtn = historyItem.querySelector("[data-tryon-history-dislike]");
      if (likeBtn) likeBtn.classList.toggle("is-active");
      if (dislikeBtn) dislikeBtn.classList.remove("is-active");
    } catch (e) {}
    return;
  }

  if (event.target.closest("[data-tryon-history-delete]")) {
    const instance = getInstanceFromModalChild(historyItem);
    if (!instance) return;

    event.preventDefault();

    const historyId = historyItem.getAttribute("data-tryon-history-id");
    if (!historyId) {
      alert("Missing history id");
      return;
    }

    const ok = window.confirm("Delete this try-on?");
    if (!ok) return;

    try {
      await instance.deleteHistoryItem(historyId);
      historyItem.remove();
      instance.updateHistoryCount();
    } catch (error) {
      alert(error.message || "Delete failed");
    }

    return;
  }
}

    document.querySelectorAll("[data-chinasquad-tryon]").forEach((root) => {
      const instance = instances.get(root);
      if (!instance || !instance.isOpen()) return;

      const modal = getModalFromRoot(root);
      const dialog = modal ? modal.querySelector(".chinasquad-tryon__dialog") : null;
      const clickedInsideDialog = dialog && dialog.contains(event.target);

      if (!clickedInsideDialog) {
        instance.closeModal();
      }
    });
  });

  document.addEventListener("change", function (event) {
    const target = event.target;
    if (!target) return;

    const fileInput = target.closest("[data-tryon-file]");
    if (fileInput) {
      const instance = getInstanceFromModalChild(fileInput);
      if (!instance) return;

      instance.refreshElements();

      const file = fileInput.files && fileInput.files[0];
      if (!file) return;

      instance.handleUserFile(file);
      return;
    }

    const isVariantInput =
      target.name === "id" ||
      target.name === "options" ||
      target.matches?.("select[name='id']") ||
      target.matches?.("input[name='id']") ||
      target.closest?.("variant-selects") ||
      target.closest?.("product-form");

    if (!isVariantInput) return;

    document.querySelectorAll("[data-chinasquad-tryon]").forEach((root) => {
      const instance = getInstanceFromRoot(root);
      if (!instance) return;

      setTimeout(function () {
        instance.syncVariantFromPage();
      }, 100);
    });
  });

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;

    document.querySelectorAll("[data-chinasquad-tryon]").forEach((root) => {
      const instance = instances.get(root);
      if (!instance || !instance.isOpen()) return;
      instance.closeModal();
    });
  });

  window.addEventListener("popstate", function () {
    document.querySelectorAll("[data-chinasquad-tryon]").forEach((root) => {
      const instance = getInstanceFromRoot(root);
      if (!instance) return;

      setTimeout(function () {
        instance.syncVariantFromPage();
      }, 100);
    });
  });

  window.addEventListener("resize", function () {
    document.querySelectorAll("[data-chinasquad-tryon]").forEach((root) => {
      const instance = getInstanceFromRoot(root);
      if (!instance) return;

      if (instance.isOpen()) {
        instance.applyResponsiveMode();
      } else {
        instance.clearResponsiveMode();
      }
    });
  });
})();